import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as styles from './Tip.css';
import { PropsWithChildren } from 'react';
import { faLightbulbOn } from '@fortawesome/pro-regular-svg-icons';
import { Typography } from '@design-system/components/typography/typography';

export const TipsContainer = (p: PropsWithChildren) => {
  return <div className={styles.container}>{p.children}</div>;
};

export const Tip = (p: PropsWithChildren) => {
  return (
    <div className={styles.tip}>
      <FontAwesomeIcon icon={faLightbulbOn} className={styles.tipIcon} />
      <Typography variant="body" size="large" fontWeight="medium">
        {p.children}
      </Typography>
    </div>
  );
};
